import { render, staticRenderFns } from "./UserConfirmOTP.vue?vue&type=template&id=791a0a52&scoped=true&"
import script from "./UserConfirmOTP.vue?vue&type=script&lang=js&"
export * from "./UserConfirmOTP.vue?vue&type=script&lang=js&"
import style0 from "./UserConfirmOTP.vue?vue&type=style&index=0&id=791a0a52&prod&lang=css&"
import style1 from "./UserConfirmOTP.vue?vue&type=style&index=1&id=791a0a52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a0a52",
  null
  
)

export default component.exports